import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Pivot, PivotItem } from '@fluentui/react/lib/Pivot';
import { SearchScenarioId } from 'owa-search-store';
import { startSearch } from 'owa-search-actions';
import { getStore, lazySetActiveSearchTab, SearchTab } from 'owa-mail-search';
import styles from './InboxPivotStyles.scss';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(styles);

export interface SearchResultsPivotProps {
    mailListHeaderStylesAsPerUserSettings: string;
}

// TODO: move to a search package. https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/125252
export default observer(function SearchResultsPivot(props: SearchResultsPivotProps) {
    const onPivotItemClicked = async (item: PivotItem) => {
        const setActiveSearchTab = await lazySetActiveSearchTab.import();
        setActiveSearchTab(item.props.itemKey as SearchTab);
        startSearch(
            'TabbedSearchPivot-' + item.props.itemKey /* actionSource */,
            SearchScenarioId.Mail,
            true /* explicitSearch */,
            [] /* connectedAccountInfo */,
            null /* searchProvider */,
            null /* filter */
        );
    };

    const renderMailPivot = (): JSX.Element => {
        return <PivotItem headerText="Mail" itemKey={'Mail'} />;
    };
    const renderFilesPivot = (): JSX.Element => {
        return <PivotItem headerText="Files" itemKey={'Files'} />;
    };

    return (
        <div className={styles.pivotContainer}>
            <Pivot
                styles={{
                    link: classNames(
                        styles.nonSelectedPivotLink,
                        props.mailListHeaderStylesAsPerUserSettings
                    ),
                    linkIsSelected: classNames(
                        styles.selectedPivotLink,
                        props.mailListHeaderStylesAsPerUserSettings
                    ),
                    linkContent: styles.linkContent,
                    text: styles.searchPivotText,
                }}
                selectedKey={getStore().activeSearchTab || 'Mail'}
                onLinkClick={onPivotItemClicked}>
                {renderMailPivot()}
                {renderFilesPivot()}
            </Pivot>
        </div>
    );
});
